import React from 'react'
import ApiRequest from 'EurestoApi/ApiRequest'
import project from 'EurestoConfig/project.config'

export default props => {

  const add = async (object) => {
    return await ApiRequest(project.api + (props.addModule || props.module), {
      action: props.addAction || 'add',
      requete: props.addRequete || props.requete,
      ...object
    }, props.config)
  }

  const update = async (object) => {
    return await ApiRequest(project.api + (props.updateModule || props.module), {
      action: props.updateAction || 'update',
      requete: props.updateRequete || props.requete,
      ...object
    }, props.config)
  }

  const rm = async (object) => {
    return await ApiRequest(project.api + (props.deleteModule || props.module), {
      action: props.deleteAction || 'delete',
      requete: props.deleteRequete || props.requete,
      ...object
    }, props.config)
  }

  const archive = async (object) => {
    return await ApiRequest(project.api + (props.archiveModule || props.module), {
      action: props.archiveAction || 'archive',
      requete: props.archiveRequete || props.requete,
      ...object
    }, props.config)
  }

  const unarchive = async (object) => {
    return await ApiRequest(project.api + (props.unarchiveModule || props.module), {
      action: props.unarchiveAction || 'unarchive',
      requete: props.unarchiveRequete || props.requete,
      ...object
    }, props.config)
  }

  const get = async (object) => {
    return await ApiRequest(project.api + (props.getModule || props.module), {
      action: props.getAction || 'get',
      requete: props.getRequete || props.requete,
      ...object
    }, props.config)
  }

  return {
    add,
    update,
    delete: rm,
    archive,
    unarchive,
    get
  }
}


// WEBPACK FOOTER //
// ./app/Utilitaire/Hook/useActionRequest/index.js